import { custom, PropSchema } from "serializr";
import { Big } from 'big.js';

const typeCache: { [label: string]: boolean } = {};

export function type<T>(label: T | ''): T {

  if (typeCache[label as string]) {
    throw new Error(`The action type "${label}" is not unique"`);
  }

  typeCache[label as string] = true;

  return label as T;
}

function bigSerializer(sourcePropertyValue: Big): string {
  if (sourcePropertyValue == null) {
    return null;
  }
  return new Big(sourcePropertyValue).toFixed(2);
}

function bigDeserializer(jsonValue: any, context?: any, oldValue?: any): Big {
  if (jsonValue == null) {
    return null;
  }
  return new Big(jsonValue);
}

export const bigSchema: PropSchema = custom(bigSerializer, bigDeserializer);
